import routes from './router'
import Router from 'vue-router'
// import {post} from './api/index'
import {get,post} from '@/utils/axios_config'
import {formatRoutes,loadView} from '../store/store'
const createRouter = () => new Router({
  routes,
})
let isMenus = false;
const router = createRouter();

const white_list = ['/login','/cloud','/login_auto','/external_large','/workshop','/cockpit','/cockpit_swiper','/weiquan_swiper','/system_ceshi','/admin_large','/warehouse_large'] // 免登录白名单
router.beforeEach(async(to, from, next) => {
	let token = sessionStorage.getItem('user_token');
	document.title = process.env.API_IMG_TITLE;
	if(white_list.indexOf(to.path) != -1){
		next()
	}else if(!token){
		next({path: '/login?redirect='+to.path })
	}else if(to.path == '/'){
		var link = '/index';
	    var general_flag = sessionStorage.getItem('general_flag') || '0';
	    var user = sessionStorage.getItem('user') || '0';
	    var front_show_type = user.front_show_type;
		if(general_flag=='1'){
			link = "/indexShenyang"
		}else{
			if(front_show_type=='1'){
				link = "/indexShenyang"
			}
		}
		next({path: link })
	}else{
	    if(!isMenus){
				isMenus =true;
				var controller = sessionStorage.getItem('controller') || 'admin_base_api';
				var url = controller + "/common";
				var {menu} = await post(url,{'ceshi':'1'}, false);
				var secure = [];
				var production = [];
				var new_menu = [];
				for (var i = 0; i < menu.length; i++) {
					if(menu[i].link=='secure'){
						secure.push(menu[i]);
					}else if(menu[i].link=='production'){
						// production.push(menu[i]);
						new_menu.push(menu[i]);
					}else{
						new_menu.push(menu[i]);
					}
				}
				var list=formatRoutes(new_menu,[]);
				var secure_list=formatRoutes(secure,[]);
				var production_list=formatRoutes(production,[]);
				router.addRoute({path: '/', name: '生产管理', component:loadView('production'), children: production_list});
				router.addRoute({path: '/', name: '安全管理', component:loadView('secure'), children: secure_list});
				router.addRoute({path: '/', name: '', component:loadView('home'), children: list});
				next({...to, replace:true});
	    }else{
	    	next();
	    }
	}
})

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default router


// WEBPACK FOOTER //
// ./src/permission.js